module.exports = __webpack_public_path__ + "static/media/lead.57d18b67.png";